/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Alert,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  DropdownItem,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  Button
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  editCompanyFieldChange,
  editEmailFieldChange,
  editNumberCancel,
  editNumberField,
  editNumberFieldChange as editNumberFieldChangeAction,
  getCompanyNumbers,
  getNumberByID,
  uploadFile,
  getObiCallerOverRide
} from '../../../actions/Numbers';
import util, { isEscene } from '../../../lib/utils';
import CompanyAutocomplete from '../../CompanyAutocomplete';
import MultiInput from '../../MultiInput';
import NumberTypeSelect from '../../Numbers/NumberTypeSelect';
import UsersAutocomplete from '../../Numbers/UsersAutocomplete';
import remove from '../../../Res/Icon/remove.png';
import MultiInputDrag from '../../MultiInputDrag';
import { getVoicePorts, getModemPorts,getFaxHuntPorts, editAssignedNumber, getPortValues, clearPortConfigChangesMade, setPortConfigChangesMade, setPortConfigModalSource, clearPortConfigModalSource } from '../../../actions/EpikBoxes';
import { getPortConfigTemplates, setSelectedPortConfigTemplate } from '../../../actions/PortConfig';

import { assignRouteInfo, getNumberOrderList } from '../../../actions/Provisioning';
import NumberAutocomplete from '../../NumberAutocomplete';
import NumberRoute from '../../Numbers/NumberRoute';
import Toggle from '../../Toggle';
import { VMAIL_PROPERTY, VMAIL_ROUTE, TOOLTIPS_TEXT } from '../../../lib/constants';
import {
  advModemConfig,
  changeAction,
  changeBulkBoxSession,
  enableBulkBoxSession,
  resetBulkBoxSession,
  callerIdOverride,
  blockCallerIdConfig,
} from '../../../actions/BoxSessionLogging';
import AlarmProtocol from './AlarmProtocol';
import WarningModal from '../../WarningModal';
import utils from '../../../lib/utils';
import InfoPopup from '../../InfoPopup';
import loadingSpinner from '../../../Res/loadingSpinner.svg';
import NumberOrderHistoryModal from '../../NumberOrderHistoryModal';
import ConfirmationModal from '../../ConfirmationModal';
import SpinnerCircles from '../../Spinner/SpinerCircles';
import { CommonDropdown } from '../../common';
import { evenValues, oddValues, dialToneOnly } from '../constants';
import getObiData from '../../../containers/epikBoxes/helpers';
import PortConfigModal from './PortConfigModal';
import { getStateCountry } from '../../../actions/ProposalsEditor';
import * as ProvisioningActions from '../../../actions/Provisioning';
import { getPermissionForComponent } from '../../../utils/permissionsUtils';

import DeleteModal from '../../DeleteModal';
import { esceneFromObiValues } from '../../../utils/constants';

const groupItems = [
  {
    label: 'Sequential',
    value: 'Round Robin',
    tooltip: 'Rings each port in a defined sequence for 30 seconds before ringing next port',
  },
  { label: 'Ring All', value: 'Ring All', tooltip: 'Rings all numbers at the same type' },
];

class EditNumberForm extends PureComponent {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');
    this.onNumberChange = this.onNumberChange.bind(this);
    this.state = {
      prepend: false,
      append: false,
      same: false,
      cidOverride: props?.number?.cidOverride || '',
      ports: [],
      selectGroup: groupItems.find(item => item.value === props?.number?.huntType) || groupItems[0],
      numberConfirmation: null,
      advancedModemConfiguration: false,
      blockCallerId: false,
      inbandRouting: false,
      cnameEnable: false,
      callIdOverride: null,
      portAssignedDids: [],
      portSelectedDid: null,
      vmailFile: false,
      loadingVmail: true,
      orderHistoryModal: [],
      tempType: null,
      warningText:'',
      portConfigTemplates: null,
      portConfigTemplateLoading: false,
      portConfigurationValues: null,
      implementedPortConfiguration: {},
      showPortConfigModal: false,
      portConfigLoading: false,
      callerIdMasking: props.selectedPort?.callerIdMasking || false,
      callerIdMaskingNumber: props.selectedPort?.callerIdMaskingNumber || '',
      CallerMaskingTypeNumbers: [],
      states: [],
      initialPorts: [],
      initialHuntType: '', 
      initialNumberType: '',
      lineTypeChangeWarning: false,
      customPortConfigTemplates: null,
      customPortConfig: props.selectedAta?.appliedConfigTemplate ? !props.selectedAta?.appliedConfigTemplate.default : false,
      portConfigurationAccess: false,
      callerIdMaskingAccess: false,
      onlyEfax: props.number.onlyEfax ?? false, 
      deleteModalStatus : false,
      selectedPortTypeData : null,
      portConfigValueChanged: false,
    };
    
    // Use instance property to persist port config changes flag across re-renders
    this.portConfigChangesMadeRef = false;
    
    this.portArr = [];
  }

  onToggleCallerIDMask = (suggestion) => {
    this.setState((prevState) => {
      const updatedCallerIdMasking = !prevState.callerIdMasking;
      this.props.editNumberFieldChange('callerIdMasking', updatedCallerIdMasking);
      return { callerIdMasking: updatedCallerIdMasking };
    });
  };

  onCallerIdMaskingNumberChange = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      const callerIdMaskingNumber = selectedOption.value;

      this.setState({ callerIdMaskingNumber }, () => {
        this.props.editNumberFieldChange('callerIdMaskingNumber', callerIdMaskingNumber);
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.callerIdMasking !== this.state.callerIdMasking) {
      if (!this.state.callerIdMasking) {
        this.setState({ callerIdMaskingNumber: '' });
        this.props.editNumberFieldChange('callerIdMaskingNumber', '');
      }
    }
  }

  async componentDidMount() {
    this.filterSpecificTypeNumbers();
    //reset bulk box session
    this.props.resetBulkBoxSession();

    const uid = true;
    const {
      number,
      getNumberByID,
      editNumberFieldChange,
      getCompanyNumbers,
      editNumberField,
      boxDetails,
      selectedPort,
      selectedAta,
      vmail,
      advModemConfig,
      blockCallerIdConfig,
      numberByID,
      type,
      user
    } = this.props;
    const portConfigurationAccessPermission = getPermissionForComponent('portConfigurationAccess',user.permissionsGroup);
    this.setState({ portConfigurationAccess: portConfigurationAccessPermission })
    const callerIdMaskingAccessPermission = getPermissionForComponent('callerIdMaskingAccess',user.permissionsGroup);
    this.setState({ callerIdMaskingAccess: callerIdMaskingAccessPermission })

    this.setState({
      advancedModemConfiguration: selectedPort.advancedModemConfiguration,
      callIdOverride: !!selectedPort?.callerIdOverride,
      blockCallerId: selectedPort.blockCallerId,
      inbandRouting: numberByID.inbandRouting,
      callerIdMasking: selectedPort.callerIdMasking,
      callerIdMaskingNumber: selectedPort.callerIdMaskingNumber,
    });

    if (type) {
      await this.fetchPortTemplatesList(boxDetails.datacenter, type, true);
    }
    advModemConfig(selectedPort.advancedModemConfiguration);
    blockCallerIdConfig(selectedPort.blockCallerId);
    const obisResult = this.getAllPortDids();
    this.setState({ portAssignedDids: obisResult });
    const companyId = vmail ? boxDetails.assignedTo._id : number?.company?._id;
    if (companyId) {
      await getCompanyNumbers(this.token, companyId, uid);
    }
    const updateNumberByID = await getNumberByID(this.token, number?._id || '');
    await this.getVmailFile(this.token, number._id);
    editNumberField('numberByID', this.props.numberByID);
    editNumberFieldChange('company', boxDetails.assignedTo._id);
    editNumberFieldChange('companyID', boxDetails.assignedTo._id);
    editNumberFieldChange('huntType', updateNumberByID?.huntType || '');
    editNumberFieldChange('huntPorts', utils.removeNullish(updateNumberByID?.huntPorts) || '');
    this.portArr = utils.removeNullish(updateNumberByID?.huntPorts) || [];
    this.setState({ ports: utils.removeNullish(updateNumberByID?.huntPorts) || [] });
    editNumberFieldChange('assignedTo', {
      _id: boxDetails.epikBoxUser._id,
      email: boxDetails.epikBoxUser.email,
    });
    editNumberFieldChange('numDigits', 1);
    editNumberFieldChange('cidOverride', number?.cid || '');
    editNumberFieldChange('spoofType', number?.spoofType || 'none');
    editNumberFieldChange(
      'changedPort',
      selectedAta?.boxPortNumber.toLowerCase().replace(' ', '') || '',
    );
    editNumberFieldChange('portLabel', selectedAta?.assignedNumberRef?.portLabel);
    editNumberFieldChange('callerIdName', number?.callerIdName);
    editNumberFieldChange('callerIdMaskingNumber', selectedPort?.callerIdMaskingNumber);
    editNumberFieldChange('callerIdMasking', selectedPort?.callerIdMasking);

    this.handleNumberType({ target: { value: 'spoofType' } }, number?.spoofType || 'none');
    const selectedGroup = groupItems.find(item => item.value === updateNumberByID?.huntType) || groupItems[0];
    console.log('test________________', this.props.numberByID?.huntType);
    console.log('test___________________', this.props.numberByID?.huntType);

    this.setState({
      selectGroup: selectedGroup,
      cnameEnable: !!number?.callerIdName,
      initialPorts: updateNumberByID ? utils.removeNullish(updateNumberByID?.huntPorts) : [],
      initialHuntType: updateNumberByID ? updateNumberByID?.huntType : '',
      initialNumberType: updateNumberByID ? updateNumberByID?.type : ''
      // portConfigTemplates,
    });
    if(updateNumberByID && (updateNumberByID?.type === 'hunt' || updateNumberByID?.type === 'modemHunt' || updateNumberByID?.type === 't38hunt')){
      await this.handlePortData(updateNumberByID?.type);
    }

    if (vmail) {
      this.VoiceMailChecks();
    }
  }  

  handlePortData = async (type) => {
    const { getVoicePorts, getModemPorts, selectedAta, boxDetails,getFaxHuntPorts } = this.props;
    const { ports } = this.state;
    let res = null;
    if (type === 'hunt') { 
      res = await getVoicePorts(this.token, boxDetails._id);
    } else if (type === 'modemHunt') {
      res = await getModemPorts(this.token, boxDetails._id);
    } else if (type === 't38hunt') {
      res = await getFaxHuntPorts(this.token, boxDetails._id);
      console.log('mian res',res);
      
    }
    // if(res) {
    //   this.allPorts = res;
    //   const selectedPort = this.allPorts[0];
    //   this.setState({
    //     selectedPort,
    //     ports: ports.length ? ports : res.slice(0, 1),
    //   }, () => {
    //     this.props.editNumberFieldChange('huntPorts', this.state.ports);
    //   });
    //   const isDifferentPort = selectedAta?.boxPortNumber !== selectedPort;
    //   const portsWithoutDash = utils.removeDashes(this.state.ports);
    //   if (isDifferentPort && selectedAta?.boxPortNumber) {
    //     portsWithoutDash.unshift(selectedAta?.boxPortNumber);
    //     const result = portsWithoutDash.filter((item, pos, self) => self.indexOf(item) === pos);
    //     this.setState({ ports: result });
    //   }
    // }
    if (res) {
      this.allPorts = res;
      const selectedPort = this.allPorts[0];
    
      if (type === 't38hunt') {
        this.setState(
          {
            selectedPort: '',
            ports: ports.length ? ports : [],
          },
          () => {
            this.props.editNumberFieldChange('huntPorts', this.state.ports);
          }
        );
      
        return;
      }
    
      this.setState({
        selectedPort,
        ports: ports.length ? ports : res.slice(0, 1),
      }, () => {
        this.props.editNumberFieldChange('huntPorts', this.state.ports);
      });
      const isDifferentPort = selectedAta?.boxPortNumber !== selectedPort;
      const portsWithoutDash = utils.removeDashes(this.state.ports);
      if (isDifferentPort && selectedAta?.boxPortNumber) {
        portsWithoutDash.unshift(selectedAta?.boxPortNumber);
        const result = portsWithoutDash.filter((item, pos, self) => self.indexOf(item) === pos);
        this.setState({ ports: result });
      }
    }
  }

  async componentWillMount() {
    const allStates = await this.props.getStateCountry(this.token);
    if (allStates) {
      this.setState({ states: allStates });
    }
  }

  async getVmailFile(token, numberID) {
    if (!numberID) {
      this.setState({ vmailFile: false, loadingVmail: false });
      return false;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_MYEPIK_URL}v2/numbers/vmail-file/${numberID}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (!response.ok) {
        this.setState({ vmailFile: false, loadingVmail: false });
      }
      const data = await response.json();

      if (data && data.failure) {
        this.setState({ vmailFile: false, loadingVmail: false });
      }

      this.setState({ vmailFile: data, loadingVmail: false });
    } catch (error) {
      console.log(error);
      this.setState({ vmailFile: false, loadingVmail: false });
    }
  }

  async componentWillUnmount() {
    this.portArr = [];
    this.setState({ ports: [] });
    this.props.editNumberCancel();
  }

  onNumberChange(faxNumber) {
    const { editNumberFieldChange } = this.props;
    editNumberFieldChange('number', faxNumber);
  }

  VoiceMailChecks = () => {
    this.onNumberTypeSelect(VMAIL_PROPERTY);
    this.onSelectRoute(VMAIL_ROUTE);
  };

  sortPort = () => {
    const { selectedAta } = this.props;
    if (this.allPorts) {
      let filtered = this.allPorts.filter(function (value) {
        return value !== selectedAta?.boxPortNumber;
      });
      filtered = filtered.filter(val => {
        return this.state.ports.indexOf(val) == -1;
      });
      return filtered.sort() || [];
    }
    return [];
  };

  getAllPortDids = () => {
    const { boxDetails, selectedPort } = this.props;
    const { Obis } = boxDetails;
    const obisResult = Obis?.reduce((filteredArr, obi) => {
      const port1 =
        obi?.port1?.assignedNumber && selectedPort?.boxPortNumber !== obi?.port1?.boxPortNumber;
      const port2 =
        obi?.port2?.assignedNumber && selectedPort?.boxPortNumber !== obi?.port2?.boxPortNumber;
      if (port1) {
        filteredArr.push(obi?.port1?.assignedNumber);
      }
      if (port2) {
        filteredArr.push(obi?.port2?.assignedNumber);
      }
      return filteredArr;
    }, []);

    return obisResult;
  };

  onEditCompany = async ({ suggestion }) => {
    // [BulkAction] - Change
    const {
      changeBulkBoxSession,
      editEmailFieldChange,
      editNumberFieldChange,
      boxDetails,
    } = this.props;

    const uid = true;
    if (suggestion) {
      changeBulkBoxSession(
        `Company Changed from ${boxDetails?.assignedTo?.name} to ${suggestion?.name}`,
        'company',
      );
      await this.props.getCompanyNumbers(this.token, suggestion._id, uid);
      editNumberFieldChange('company', boxDetails.assignedTo._id);
      editNumberFieldChange('companyID', boxDetails.assignedTo._id);
      editNumberFieldChange('companyName', boxDetails.assignedTo.name);
      editEmailFieldChange(this.props.email.emails);
      editNumberFieldChange('assignedTo', {
        _id: boxDetails.epikBoxUser._id,
        email: boxDetails.epikBoxUser.email,
      });
    } else {
      editNumberFieldChange('userName', '');
    }
  };

  onEditConfirmationEmail = e => {
    // [BulkAction] - Change
    const { number } = this.props;
    this.props.changeBulkBoxSession(
      `Email Confirmation Changed from ${number?.confirmationEmail || '-'} to ${e.target.value}`,
      'emailConfirmation',
    );
    this.props.editNumberFieldChange('confirmationEmail', e.target.value);
  };

  onEditEmailChange = ({ name, suggestion }) => {
    if (suggestion) {
      this.props.editNumberFieldChange(name, suggestion._id);
    } else {
      this.props.editNumberFieldChange(name, '');
    }
  };

  handleTypeChange = (selectedType, check) => {
    const { type: currentTypeValue } = this.props;
    const { value: selectedTypeValue } = selectedType || {};

    if (currentTypeValue === 'fax' && selectedTypeValue !== 'fax') {
      this.setState({
        tempType: selectedType,
        warningText: 'This change will remove all associated email addresses.',
      });
    } else {
      this.onNumberTypeSelect(selectedType, check);
    }
  };

  handleTypeChange = (selectedType, check) => {
    const { type: currentTypeValue } = this.props;
    const { value: selectedTypeValue } = selectedType || {};
    const isUnsupportedype = selectedTypeValue === 'alarm' || selectedTypeValue === 'fireAlarm';
    if (isUnsupportedype) {
      this.setState({ callerIdMasking: false, callerIdMaskingNumber: '' });
      this.props.editNumberFieldChange('callerIdMasking', false);
      this.props.editNumberFieldChange('callerIdMaskingNumber', '');
    }
    if (currentTypeValue === 'fax' && selectedTypeValue !== 'fax') {
      this.setState({
        tempType: selectedType,
        warningText: 'This change will remove all associated email addresses.',
      });
    } else {
      this.onNumberTypeSelect(selectedType, check);
    }
  };

  fetchPortTemplatesList = async (dc, portType = '', setInitialValues = false, previousType = false) => {

    if (!portType || !dc) return
    this.setState({ portConfigTemplateLoading: true })
    const {  selectedAta, boxDetails } = this.props;
    const obi = getObiData(selectedAta.boxPortNumber, boxDetails);
    const ataType = isEscene(obi?.macAddress) ? 'granite' : 'obi'
    const compID= boxDetails?.assignedTo?._id
    const portConfigTemplates = await this.props.getPortConfigTemplates(this.token, dc, portType, ataType ,compID);
    // const customPortTemplates = []
    const customPortTemplates = portConfigTemplates.filter(el => el.default == false || el.default == true)
    const portConfigTempName = selectedAta?.appliedConfigTemplate?.title
    // let portConfig = { name: portConfigTempName, title: selectedAta?.appliedConfigTemplate?.name };
    let portConfig = {};
    if (setInitialValues || previousType) {
      portConfig = { ...selectedAta.appliedConfigTemplate }
      let appliedConfigTemplate = { ...selectedAta.appliedConfigTemplate }
      const keysToDelete = ['_id', 'name', 'title', '__v', 'default'] // don't want to override these values
      keysToDelete.forEach(key => delete appliedConfigTemplate[key])

      Object.keys(appliedConfigTemplate).map(key => {
        if (!!selectedAta[key]) { appliedConfigTemplate[key] = selectedAta[key] }
      }) 

      // if(selectedAta?.appliedConfigTemplate?.showInbandRouteToggle){
      //   appliedConfigTemplate.inbandRoute = selectedAta?.appliedConfigTemplate?.inbandRoute
      // }
      // if(selectedAta?.appliedConfigTemplate?.showTrunkSelectionToggle){
      //   appliedConfigTemplate.trunkSelection = selectedAta?.appliedConfigTemplate?.trunkSelection
      // }
      // add back deleted values
      appliedConfigTemplate = { ...selectedAta.appliedConfigTemplate, ...appliedConfigTemplate }
      this.props.setSelectedPortConfigTemplate(appliedConfigTemplate) //set selected port config template in redux
    }
    if (customPortTemplates && customPortTemplates?.some(template => template.title === portConfigTempName)) {
      this.setState({ portConfigValueChanged: true });
    } 

    this.setState({ portConfigTemplates, portConfigurationValues: portConfig, portConfigTemplateLoading: false, customPortConfigTemplates: customPortTemplates });
  }

  onNumberTypeSelect = async (numberType, check) => {
    const {
      editNumberFieldChange,
      type,
      resetBulkBoxSession,
      changeBulkBoxSession,
      vmail,
      boxDetails,
      selectedObi,
      number,
      numberByID,
    } = this.props;
    if (
      ['fax', 'faxStandard'].includes(numberType?.value) &&
      boxDetails.datacenter === 'ch' &&
      check &&
      type !== numberType?.value
    ) {
      this.setState({ numberConfirmation: { type: 'port', data: numberType } });
      return;
    }
    // [BulkAction] - Reset Bulk Box Session
    resetBulkBoxSession();
    // [BulkAction] - Change
    changeBulkBoxSession(
      `Number Type Changed from ${vmail ? 'vmail' : type} to ${numberType?.value}`,
      'NumberTypeSelect',
    );
    editNumberFieldChange('type', numberType?.value);

    // Clear forwardUris when type changes
    if (type !== numberType?.value) {
      editNumberFieldChange('forwardUris', []);
    }
console.log('mian numberType',numberType);

    if (numberType?.value === 'hunt' || numberType?.value === 'modemHunt' || numberType?.value === 't38hunt') {
      if(this.state.initialNumberType === numberType?.value){
        const hType = groupItems.find(hunt => hunt.value === this.state.initialHuntType) || groupItems[0];
        editNumberFieldChange('huntType', hType.value);
        this.setState({ selectGroup: hType, ports: this.state?.initialPorts || []}, async () => {
          await this.handlePortData(this.state.initialNumberType)
        });
      } else {
        const hType = groupItems.find(hunt => hunt.value === this.props?.number?.huntType) || groupItems[0];
        editNumberFieldChange('huntType', hType.value);
        this.setState({ selectGroup: hType, ports: []}, async () => {
          await this.handlePortData(numberType?.value)
        });
      }
    } else {
      editNumberFieldChange('huntPorts', []);
      editNumberFieldChange('huntType', '');
    }
    if ((number?.number?.length > 2 && type !== numberType?.value)) {
      // await this.fetchPortTemplatesList(boxDetails.datacenter, numberType?.value, true);
      const typeNotChanged = numberByID?.type === numberType?.value // if user select type after changing alot others
      console.log("numbertesting", number.type, numberType.value, typeNotChanged);
      !typeNotChanged && this.props.setSelectedPortConfigTemplate({})// remove previously useable
      await this.fetchPortTemplatesList(boxDetails.datacenter, numberType?.value, false, typeNotChanged);
    }
  };

  onUserTypeSelect = numberType => {
    const { editNumberFieldChange } = this.props;
    const number1 = numberType ? numberType?.value : '';
    if (number1 !== '' && number1 !== undefined) {
      editNumberFieldChange('assignedTo', {
        _id: numberType?.value && numberType?.value._id,
        email: numberType?.value && numberType?.value.email,
      });
    }
  };

  onAllowedUserSelect = ({ suggestion }) => {
    const { number, changeBulkBoxSession } = this.props;
    // [BulkAction] - Change
    if (suggestion !== null) {
      changeBulkBoxSession(`Allow User(s) Changed to ${suggestion?.email}`, 'allowUsers');
      let addArray = true;
      number.allowedUsers.forEach(item => {
        if (item._id === suggestion._id) {
          addArray = false;
        }
      });
      if (addArray) {
        this.onEditArrChange([...number.allowedUsers, suggestion], 'allowedUsers');
      }
    }
  };

  onEditUserChange = ev => {
    // [BulkAction] - Change
    const { number, changeBulkBoxSession, editNumberFieldChange } = this.props;

    changeBulkBoxSession(
      `Caller ID Changed from ${JSON.stringify(number?.cid) || '-'} to ${ev.target.value}`,
      'callerID',
    );
    const { name, value } = ev.target;
    editNumberFieldChange(name, value);
    editNumberFieldChange('cidOverride', value);
  };

  onEditArrChange = (ev, type) => {
    if (this.props.type === 'ringDown') {
      if (ev.length > 1) {
        toast.error("You can't add more than one number.");
      } else {
        this.props.editNumberFieldChange(type, ev);
      }
    } else {
      this.props.editNumberFieldChange(type, ev);
    }
  };

  onEditArrNumChange = ev => {
    const { number } = this.state;
    // [BulkAction] - Change
    this.props.changeBulkBoxSession(
      `Forward Number Changed from ${JSON.stringify(number?.forwardNumbers) || '-'} to ${ev.target.value
      } `,
      'forwardNumber',
    );
    const { name, value } = ev.target;
    this.props.editNumberFieldChange(name, [value]);
  };

  handleChangeUpload = async ev => {
    // [BulkAction] - Change
    this.setState({ loadingVmail: true });
    this.props.changeBulkBoxSession(`Greeting file Changed`, 'greetingFile');
    const { files } = ev.currentTarget;
    const file = new FormData();
    file.append('greeting', files[0]);

    await this.props.uploadFile(this.token, this.props.number._id, file);
    await this.getVmailFile(this.token, this.props.number._id);
    this.setState({ loadingVmail: false });
  };

  onEditNumberChange = ev => {
    const { name, value } = ev.target;
    const reg = /^[+]*[0-9]{1,11}$/g;
    if (reg.test(value)) {
      this.props.editNumberFieldChange(name, value);
    }
  };

  setCheckedBox = e => {
    this.props.editNumberFieldChange('spoofIncomingCid', e);
  };

  handleNumberDigit = e => {
    // [BulkAction] - Change
    const { number } = this.props;
    this.props.changeBulkBoxSession(
      `Number of Digits Changed from ${number?.numDigits || '-'} to ${e.target.value}`,
      'numberOfDigits',
    );
    if (e.target.value.length <= 1) {
      if (e.target.value >= 0 && e.target.value <= 3) {
        if (e.target.value == 0) {
          this.props.editNumberFieldChange('numDigits', 1);
        } else {
          this.props.editNumberFieldChange('numDigits', e.target.value);
        }
      } else {
        this.props.editNumberFieldChange('numDigits', 1);
      }
    }
  };

  handleNumberType = (e, type) => {
    // [BulkAction] - Change
    this.props.changeBulkBoxSession(`spoofType changed to ${type}`, 'samePrependAppend');

    if (type === 'append') {
      this.setState({ append: true });
      this.setState({ prepend: false });
      this.setState({ same: false });
    }
    if (type === 'prepend') {
      this.setState({ prepend: true });
      this.setState({ append: false });
      this.setState({ same: false });
    } else if (type === 'same') {
      this.setState({ append: false });
      this.setState({ prepend: false });
      this.setState({ same: true });
    }
    this.setState({ [e.target.name]: type });
    this.props.editNumberFieldChange(e.target.name, type);
  };

  removeValue = e => {
    const { number, user } = this.props;
    if (user.role !== 'admin') {
      const valuesWIthRemoved = number.allowedUsers.filter((val, idx) => idx !== e);
      this.onEditArrChange(valuesWIthRemoved, 'allowedUsers');
    }
  };
  setPortName = e => {
    const indexData = this.allPorts.indexOf(e);
    this.allPorts.slice(indexData, 1);
    const { selectedAta, editNumberFieldChange } = this.props;
    this.setState({ selectedPort: e });
    let found = false;
    if (selectedAta?.boxPortNumber === e) {
      toast.error('Cannot select box port');
      return;
    } else if (this.state.ports.length === 0) {
      this.state.ports.push(e);
    } else {
      this.state.ports.forEach((item, idx) => {
        if (item === e) {
          found = true;
        }
        if (idx === this.state.ports.length - 1) {
          if (found) {
            toast.error('Port already selected');
          } else {
            this.state.ports.push(e);
          }
        }
      });
    }
    const portsWithoutCurrent = this.state.ports.filter(
      port => port !== selectedAta?.boxPortNumber
    );
    const updatedPorts = [
      selectedAta?.boxPortNumber,
      ...portsWithoutCurrent,
    ].filter(Boolean);
  
    editNumberFieldChange('huntPorts', updatedPorts);
    this.setState({ ports: updatedPorts });
  };

  move = (from, to, arr = this.state.ports) => {
    const { editNumberFieldChange, selectedAta } = this.props;
    const clone = [...arr];
    Array.prototype.splice.call(
      clone,
      to + 1,
      0,
      Array.prototype.splice.call(clone, from + 1, 1)[0],
    );
    const filtered = clone.filter(function (value) {
      return value !== selectedAta?.boxPortNumber;
    });

    this.setState({ ports: [selectedAta?.boxPortNumber].concat(filtered) }, () => {
      editNumberFieldChange('huntPorts', this.state.ports);
    });
  };

  removePort = e => {
    const { editNumberFieldChange } = this.props;
    const array = [...this.state.ports];
    const item = array.splice(e, 1);
    if (!this.allPorts?.includes(...item)) {
      this.allPorts = [...new Set([...this.allPorts, ...item])];
    }
    this.setState({ selectedPort: item });
    this.setState({ ports: array }, () => {
      editNumberFieldChange('huntPorts', [...new Set(array)]);
    });
  };


  typeCheck = () => {
    const { number, user, boxDetails } = this.props;
    if (user.role === 'admin' || user.role === 'enterpriseAdmin') {
      return true;
    }
    if (
      boxDetails.myEpik === true &&
      (number.type === 'dialout' || number.type === 'fax' || number.type === 'vmail')
    ) {
      return true;
    }
    return false;
  };

  onSelectRoute = e => {
    const { selectRoute, number, editNumberFieldChange } = this.props;

    if (number.carrier === 'inteliquent' && number.type !== 'vmail') {
      editNumberFieldChange('trunk', e.trunkGroupName);

      // selectRoute(number._id, { trunk: e.trunkGroupName });

      return;
    }

    const updateSet =
      number.type === 'vmail'
        ? VMAIL_ROUTE
        : {
          routeInfo: {
            route: e.route,
            gateway: e.gateway,
          },
        };

    editNumberFieldChange('routeInfo', {
      route: e.route,
      gateway: e.gateway,
    });

    // selectRoute(number._id, updateSet);
  };

  onNumberSelect = ({ suggestion }, check) => {
    const { number, boxDetails, onEditPropertyKeyPress, vmail, changeBulkBoxSession } = this.props;
    if (suggestion !== null) {
      {
        /* number?.linkedBox is a replacement of linkedToObi */
      }
      if (suggestion?.linkedBox) {
        toast.error('Number already assigned to an Epikbox');
      } else if (vmail && suggestion.type !== 'unassigned') {
        toast.error('Cannot assign this number');
      } else if (!vmail && (suggestion.type === 'vmail' || suggestion.type === 'forward')) {
        toast.error('Cannot assign this number');
      } else if (
        !!!boxDetails?.e911Number &&
        (suggestion.type === 'vmail' || suggestion.type === 'voice')
      ) {
        toast.error('E911 must be enabled prior to assigning a voice line on the port');
      } else if (
        boxDetails.datacenter === 'ch' &&
        ['fax', 'faxStandard','t38hunt'].includes(suggestion.type) &&
        check
      ) {
        this.setState({ numberConfirmation: { data: suggestion, type: 'number' } });
      } else {
        // [BulkAction] - Change
        changeBulkBoxSession(
          `Number Changed from ${number?.number || '-'} to ${suggestion.number}`,
          'numberChanged',
        );
        this.props.editAssignedNumber(suggestion);
        const data = Object.entries(suggestion);
        data.forEach(item => {
          if (vmail) {
            if (item[0] === 'type') {
              this.props.editNumberFieldChange(item[0], VMAIL_PROPERTY.value);
            } else if (item[0] === 'routeInfo') {
              this.props.editNumberFieldChange(item[0], VMAIL_ROUTE);
            }
          } else {
            // Ensure spoofType defaults to 'none' if not assigned or empty
            if (item[0] === 'spoofType' && (!item[1] || item[1] === '')) {
              this.props.editNumberFieldChange(item[0], 'none');
            } else {
              this.props.editNumberFieldChange(item[0], item[1]);
            }
          }
        });
        this.props.editNumberFieldChange('assignedTo', boxDetails.epikBoxUser?._id);
        if (suggestion.carrier === 'inteliquent' && !suggestion.trunk)
          this.props.editNumberFieldChange('trunk', this.props.defaultTrunk);
        onEditPropertyKeyPress({
          target: { name: 'assignedNumber', value: suggestion.number },
        });
        onEditPropertyKeyPress({
          target: { name: 'serviceName', value: suggestion.type },
        });
        onEditPropertyKeyPress({
          target: { name: 'assignedNumberRef', value: suggestion },
        });
        if (!vmail) {
          this.props.assignRouteInfo(this.token, suggestion._id);
        } else {
          setTimeout(() => {
            this.onSelectRoute(VMAIL_ROUTE);
          }, 1000);
        }
        // this.fetchPortTemplatesList(boxDetails.datacenter, suggestion?.type, true);
        this.fetchPortTemplatesList(boxDetails.datacenter, suggestion?.type,);
      }
    }
  };

  onadvancedModemConfigurationChange = () => {
    const { advancedModemConfiguration } = this.state;
    const { advModemConfig } = this.props;
    advModemConfig(!advancedModemConfiguration);
    this.setState({
      advancedModemConfiguration: !advancedModemConfiguration,
    });
  };

  onaBlockIdChangeChange = newBlockCallerIdValue => {
    const { blockCallerIdConfig } = this.props;
    blockCallerIdConfig(newBlockCallerIdValue);
    this.props.updateSelectedPortBlockCallerId(newBlockCallerIdValue);
  };
  onFetchRoutingOrderInfo = async () => {
    const result = await this.props.getNumberOrderList(this.token, this.props.number._id);
    if (!result.length) toast.info('No order(s) found.');
    this.setState({ orderHistoryModal: result });
  };
  onCustomWarningCancel = () => {
    this.setState({ warningText: '' });
  };
  onCustomWarningConfirm = () => {
    const { editNumberFieldChange } = this.props;
    this.onNumberTypeSelect(this.state.tempType, true);
    editNumberFieldChange('emails', []);
    editNumberFieldChange('fallbackEmails', []);
    editNumberFieldChange('confirmationEmail', '');
    editNumberFieldChange('faxDeliveryConfirmation', false);
    this.setState({ warningText: '' });
  }

  onPortConfigure = async () => {
    // Set Redux state to track that modal is opened from "Port Configuration" button
    if (this.props.setPortConfigModalSource) {
      this.props.setPortConfigModalSource('portConfigButton');
    }
    
    this.setState({ portConfigLoading: true })
    const { getPortValues, selectedAta, boxDetails } = this.props;
    const portIdx = selectedAta.boxPortNumber.split(' ')[1];
    const obi = getObiData(selectedAta.boxPortNumber, boxDetails);
    const obiId= obi._id
    const values = portIdx % 2 === 0 ? evenValues : oddValues;
    let res = await getPortValues(this.token, obiId, values);
    if (res) {

      const currentPortConfigurationObject = this.state.portConfigurationValues
      if (currentPortConfigurationObject) {//if template is changed then overwrite the values
        const settingsList = res?.data?.settings;
        for (let index = 0; index < settingsList?.length; index++) {
          let element = settingsList[index];
          let propertyName = element.name.split('.')
          propertyName = propertyName[propertyName.length - 1];
          let valueByPropertyName = currentPortConfigurationObject[propertyName];

          // convert ring voltage value from obi to escene
          if (
            isEscene(obi?.macAddress) &&
            propertyName === 'RingVoltage' &&
            !Object.values(esceneFromObiValues).includes(`${valueByPropertyName}`)
          ) {
            valueByPropertyName = esceneFromObiValues[valueByPropertyName];
          }

          if (valueByPropertyName) {
            element = { ...element, dbValue: valueByPropertyName }
            settingsList[index] = { ...settingsList[index], ...element } //update values according to current selected template
          }
        }
        res = { ...res, data: { ...res.data, settings: settingsList } };
      }
      this.setState({ implementedPortConfiguration: { ...res } }, () => {
        this.setState({ showPortConfigModal: true, portConfigLoading: false, lineTypeChangeWarning: false })
      })
    }
  };

  onPortConfigTemplateChange = (val) => {
    const templates = this.state.portConfigTemplates;
    let portValues = {}
    templates?.map(el => {
      if (el.title === val) {
        portValues = { ...el }
        return
      }
    });
    // override values for escene; for time being no need
    // if(isEscene(this.props.selectedObi?.macAddress) && !Object.values(esceneFromObiValues).includes(portValues.RingVoltage)){
    //   portValues= {...portValues, RingVoltage: esceneFromObiValues[portValues.RingVoltage]}      
    // }
    this.props.setSelectedPortConfigTemplate(portValues) //set selected template in redux
    this.setState({ portConfigValueChanged: true });
    this.setState({ portConfigurationValues: portValues, })
  }

  customPortConfigHandler = (checkedValue) => {
    console.log("myupdate found o checkedValue", checkedValue);
    this.setState({
      customPortConfig: checkedValue,
      ...(!checkedValue && { portConfigurationValues: {} })
    })
    !checkedValue && this.props.setSelectedPortConfigTemplate({})
  }

  filterSpecificTypeNumbers = () => {
    const { assignedNumbers } = this.props;
    const CallerMaskingTypeNumbers = assignedNumbers.filter(number => number.type === 'callIdMask');
    this.setState({ CallerMaskingTypeNumbers });
  };
  handleToggle = () => {
    const newValue = !this.state.onlyEfax; 
    this.setState({ onlyEfax: newValue }); 
    this.onEditArrChange(newValue,'onlyEfax');
  };

  render() {
    const {
      companies,
      type,
      number,
      user,
      email,
      editNumberFieldChange,
      boxDetails,
      onRemoveNumber,
      updatePort,
      toggleMode,
      assignedNumbers,
      onEditPropertyKeyPress,
      selectedAta,
      vmail,
      changeBulkBoxSession,
      callerIdOverride,
      selectedPort,
      clearSearchedNumbers, 
      resetSelectedNumbers,
      selectedPortConfigTemplate,
      updateTrunkSelection,
      onTrunckSelection,
      setInbandRouting
    } = this.props;
    const {
      numberConfirmation,
      advancedModemConfiguration,
      cnameEnable,
      callIdOverride,
      portAssignedDids,
      portSelectedDid,
      warningText,
      portConfigTemplates,
      implementedPortConfiguration,
      showPortConfigModal,
      portConfigurationValues,
      portConfigLoading,
      portConfigTemplateLoading,
      callerIdMasking,
      callerIdMaskingNumber,
      CallerMaskingTypeNumbers,
      lineTypeChangeWarning,
      customPortConfig,
      customPortConfigTemplates,
      portConfigValueChanged
    } = this.state;

    const disabledAdmin = user.role === 'admin' || user.role === 'enterpriseAdmin';
    const usedToType = ['alarm', 'fireAlarm', 'modem', 'secureEntry', 'elevator', 'modemHunt'];
    const { data: { settings = [], vadEnable, extraConfigValues } = {}, validationRules, } = implementedPortConfiguration;
    const deleteModalMsg = `Number will be unassigned If type is changed to Dial Tone Only. Do you really want to unassign the number ?`;
    return (
      <div className="container numbers-container">
        <div className="row">
          <div className="text-left" style={{ width: '100%' }}>
            <FormGroup row>
              <Col sm={6}>
                <Label for="number" sm={12}>
                  Number
                </Label>
                {toggleMode ? (
                  <>
                    <Input
                      disabled
                      required
                      type="text"
                      name="number"
                      value={number && number.number}
                      onChange={this.onEditNumberChange}
                      maxLength={12}
                      id="selected_port_number"
                    />

                    {user.role !== 'admin' && (
                      <div
                        onClick={() => onRemoveNumber(true)}
                        style={{
                          cursor: 'pointer',
                          margin: '10px 0px 0px 18px',
                        }}
                        id="remove-DID"
                      >
                        <FontAwesomeIcon
                          icon="trash-alt"
                          size="sm"
                          color="#29a4ff"
                          style={{ marginRight: '0.3rem' }}
                        />
                        Remove
                      </div>
                    )}
                  </>
                ) : assignedNumbers.length !== 0 ? (
                  <NumberAutocomplete
                    showUnassigned={vmail}
                    searchTerm=""
                    placeholder="Select Number"
                    numbers={assignedNumbers}
                    onChange={data => this.onNumberSelect(data, true)}
                    states= {this.state.states}
                    clearSearchedNumbers= {clearSearchedNumbers}
                    resetSelectedNumbers={resetSelectedNumbers}
                    user={user}
                    isDisabled={type === dialToneOnly || (selectedPort?.serviceName === dialToneOnly && type == undefined)}
                  />
                ) : (
                  <Alert colSpan={2} color="info" className="price-not-found-alert">
                    No Number(s) found
                  </Alert>
                )}
              </Col>
              <Col sm={(type === 'hunt' || type === 'modemHunt') ? 2 : 3}>
                <Label for="type">Type</Label>
                <NumberTypeSelect
                  toggleClassName="col-12"
                  disabledAdmin={vmail ? true : !toggleMode ? false : this.typeCheck()}
                  onTypeSelect={data => {
                    if(number?.number && number?.number?.length > 2 && data?.value == dialToneOnly){
                      this.setState({ deleteModalStatus: true, selectedPortTypeData: data });                      
                    }else{
                      this.handleTypeChange(data, true)}
                    }
                  }
                  selectedType={
                    vmail
                      ? 'vmail'
                      : (selectedPort?.serviceName === dialToneOnly && type == undefined)
                      ? selectedPort?.serviceName
                      : (number?.number && type !=undefined)
                      ? type
                      : type == dialToneOnly
                      ? type
                      : 'unassigned'
                  }
                  e911Enabled={boxDetails?.e911Number}
                  boxDetails={boxDetails}
                  comingFrom={vmail ? 'number' : null}
                />
              </Col>
              <Col sm={(type === 'hunt' || type === 'modemHunt')  ? 2 : 3}>
                <label className="d-block">
                  <span className="mb-2 d-inline-block">Port Label</span>
                  <input
                    type="text"
                    disabled={user?.readOnly}
                    value={number?.portLabel}
                    className="form-control"
                    onChange={({ currentTarget }) => {
                      changeBulkBoxSession(
                        `Port Label updated to ${currentTarget.value}`,
                        'portLabel',
                      );
                      editNumberFieldChange('portLabel', currentTarget.value);
                    }}
                  />
                </label>
              </Col>
              {(type === 'hunt' || type === 'modemHunt' || type === 't38hunt')&& (
                <Col sm={2}>
                  <Label for="type" sm={12}>
                    Hunt Type
                  </Label>
                  {!!this.state.selectGroup ? (
                    <Input
                      type="select"
                      value={this.state.selectGroup?.value}
                      onChange={e => {
                        const newValue = e.currentTarget.value;
                        const newSelectGroup = groupItems.find(item => item.value === newValue);

                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Hunt Type Changed from ${this.state.selectGroup?.value || '-'} to ${newValue}`,
                          'huntType',
                        );
                        this.setState({ selectGroup: newSelectGroup });
                        editNumberFieldChange('huntType', newValue);
                      }}
                    >
                      {groupItems.map((item, idx) => {
                        return (
                          <option key={idx} value={item.value} title={item.tooltip}>
                            {item.label}
                          </option>
                        );
                      })}
                    </Input>
                  ) : (
                    <SpinnerCircles red={true} />
                  )}
                </Col>
              )}
            </FormGroup>
            {/* number?.linkedBox is a replacement of linkedToObi */}
            {!boxDetails.myEpik && number?.linkedBox && usedToType.includes(type) && (
              <FormGroup row>
                <Col sm={6} />
                <Col sm={6}>
                  <Row className="mb-2">
                    <Col sm={9}>
                      <Label for="checked" sm={12} className="adv-modem-config">
                        Advanced Modem Configuration
                        <sup>
                          <InfoPopup
                            id="modem-configurations"
                            text={TOOLTIPS_TEXT.ADV_MODEM_CONFIG}
                          />
                        </sup>
                      </Label>
                    </Col>
                    <Col sm={3} className="advanced-modem-configuration">
                      <Input
                        type="checkbox"
                        name="advancedModemConfiguration"
                        checked={advancedModemConfiguration}
                        onChange={this.onadvancedModemConfigurationChange}
                      />
                    </Col>
                  </Row>
                </Col>
              </FormGroup>
            )}
            {user.role === 'superAdmin' ||
              user.role === 'companyGroupAdmin' ||
              user.role === 'supportEngineer' ? (
                <FormGroup row className='align-items-end'>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <CompanyAutocomplete
                    isDisabled
                    searchTerm={boxDetails.assignedTo?.name}
                    placeholder="Filter Company..."
                    companies={companies.docs || []}
                    onChange={this.onEditCompany}
                  />
                </Col>
                  {/* //uncomment after complete testing on prod
                      // (user.role === 'superAdmin' || user?.portConfigurationAccess) && */}

                {(this.state.portConfigurationAccess === 'write' ||
                    this.state.portConfigurationAccess === 'both') &&
                    <Col sm={6}>

                    {!portConfigTemplateLoading && 
                      <Col sm={12}>
                        <Label for="customPortConfig" sm={12}>
                          <Input
                            type="checkbox"
                            id="customPortConfig"
                            onChange={(e) => {
                              console.log("selectedAta?.appliedConfigTemplate?.name checkbox ", e.target.checked);
                              this.customPortConfigHandler(e.target.checked)
                            }}
                            checked={customPortConfig}
                          />
                          Custom Port Config Settings
                        </Label>
                      </Col>
                    }

                    {portConfigTemplateLoading ?
                      <SpinnerCircles red={true} /> :
                      ((user?.portConfigurationAccess || true)) &&
                      type && type !== 'unassigned' &&
                        number?.number?.length > 3 &&
                        customPortConfig &&
                        customPortConfigTemplates?.length > 0 ?

                        <Row className='align-items-end'>
                          <Col sm={6} >
                            <CommonDropdown
                              onChange={val => this.onPortConfigTemplateChange(val)}
                              dropdownList={customPortConfigTemplates}
                              value={this.state.portConfigurationValues?.title || ''}
                              label={'Port Configuration Template'}
                              valueField='title'
                              labelField='title'
                            />
                          </Col>
                          {portConfigValueChanged && (
                          <Col sm={6}>
                            <Button color="primary"
                              onClick={this.onPortConfigure}
                              disabled={portConfigLoading}
                              >
                              {portConfigLoading ? <SpinnerCircles /> : "Port Configuration"}
                            </Button>

                          </Col>
                          )}
                          {showPortConfigModal &&
                            <PortConfigModal
                              port={selectedPort}
                              // updatePortConfig={updatePortConfig}
                              boxDetails={boxDetails}
                              settings={settings}
                              settingsValidationRules={validationRules}
                              settingsVadEnable={selectedPortConfigTemplate?.showVadToggle ? selectedPortConfigTemplate.vadEnable : vadEnable}
                              isOpen={showPortConfigModal}
                              refresh={this.onPortConfigure}
                              isClose={() => {
                                this.setState({ showPortConfigModal: false });
                                // Don't reset the ref here - only reset after Save is called
                              }}
                              templateConfig={!!portConfigurationValues}
                              selectedPortConfigTemplate={selectedPortConfigTemplate}
                              updateTrunkSelection={updateTrunkSelection}
                              onTrunckSelection={onTrunckSelection}
                              setInbandRouting={(inbandRoute) => {
                                this.setState({
                                  inbandRouting: !this.state.inbandRouting,
                                });
                                setInbandRouting(inbandRoute);
                              }}
                              inbandRouting={this.props.numbers?.numberByID?.inbandRouting || false}
                              extraConfigValues={extraConfigValues}
                              onPortConfigChangesMade={(changesMade) => {
                                // Store in instance property to persist across re-renders
                                this.portConfigChangesMadeRef = changesMade;
                                console.log('EditBoxNumber: Port config changes made flag set to:', changesMade);
                              }}
                              setPortConfigChangesMade={setPortConfigChangesMade}
                            />
                          }
                        </Row>
                        : <>
                          {customPortConfig && <p>No Custom Template Available </p>}
                        </>


                    }
                  </Col>
                  }
                {/* <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  {vmail || (number && number.assignedTo && number.assignedTo.email) ? (
                    <UsersAutocomplete
                      disabledAdmin={!vmail}
                      searchTerm={boxDetails.epikBoxUser.email}
                      callsItem={(email && email.emails) || []}
                      placeholder="User..."
                      calls={(email && email.emails) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        if (e.suggestion !== null) {
                          changeBulkBoxSession(
                            `User Changed from ${number?.assignedTo?.email || '-'} to ${e.suggestion.email
                            }`,
                            'user',
                          );
                        }
                      }}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Emails not found
                    </Alert>
                  )}
                </Col> */}
              </FormGroup>
            ) : (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <Input value={user.company && user.company.name} readOnly />
                </Col>
                {/* <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  {number && number.assignedTo && number.assignedTo.email ? (
                    <UsersAutocomplete
                      disabledAdmin={!vmail}
                      searchTerm={boxDetails.epikBoxUser.email}
                      callsItem={(email && email.emails) || []}
                      placeholder="User..."
                      calls={(email && email.emails) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        if (e.suggestion !== null) {
                          changeBulkBoxSession(
                            `Email Changed from ${boxDetails?.epikBoxUser?.email || '-'} to ${e.suggestion.email
                            }`,
                            'email',
                          );
                        }
                      }}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Emails not found
                    </Alert>
                  )}
                </Col> */}
              </FormGroup>
            )}
            {/* number?.linkedBox is a replacement of linkedToObi */}
            {!boxDetails.myEpik && number?.linkedBox && (type === 'fireAlarm' || type === 'alarm') && (
              <FormGroup row>
                <Col sm={6} />
                <Col sm={6}>
                  <AlarmProtocol user={user} />
                </Col>
              </FormGroup>
            )}

            {type === 'fax' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Email(s)
                    </Label>
                    {/* <MultiInput
                      inputData={number && number.emails ? number.emails : []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Email(s) Changed from ${JSON.stringify(
                            number?.emails ? number.emails : [],
                          )} to ${JSON.stringify(e)}`,
                          'emails',
                        );
                        this.onEditArrChange(e, 'emails');
                      }}
                      validator={util.validateEmail}
                      disabledAdmin={disabledAdmin}
                    /> */}
                    <MultiInput
                      inputData={number && number.emails ? number.emails : []}
                      onChange={values => {
                        const normalizedEmails = values
                          .map(email => (email || '').trim().toLowerCase()) // trim + lowercase each email
                          .filter(email => email.length);                   // remove empty strings
                        changeBulkBoxSession(
                          `Email(s) Changed from ${JSON.stringify(number?.emails || [])} to ${JSON.stringify(normalizedEmails)}`,
                          'emails',
                        );
                        this.onEditArrChange(normalizedEmails, 'emails');   // pass the array, no .trim()
                      }}
                      validator={value => util.validateEmail((value || '').trim())}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                  <Col sm={6}>
                      <div className="d-flex align-items-center">
                      <Label for="type" className="mb-0">
                      Fallback email(s)
                    </Label>
                    <sup className="ml-2">
                      <InfoPopup
                        id="type"
                        text={TOOLTIPS_TEXT.FALL_BACK_EMAIL}
                      />
                    </sup>
                  </div>
                    <MultiInput
                      inputData={(number && number.fallbackEmails) || []}
                      onChange={values => {
                        const normalizedFallback = values
                          .map(v => (v || '').trim().toLowerCase())
                          .filter(v => v);
                        changeBulkBoxSession(
                          `FallBack Emails Changed from ${JSON.stringify(
                            number?.fallbackEmails || [],
                          )} to ${JSON.stringify(normalizedFallback)}`,
                          'fallbackEmail',
                        );
                        this.onEditArrChange(normalizedFallback, 'fallbackEmails');
                      }}
                      validator={util.validateEmail}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12} className="adv-modem-config">
                      {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                    </Label>
                    <MultiInput
                      inputData={(number && number.forwardUris) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `${type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'
                          } Changed from ${JSON.stringify(
                            number?.forwardUris || [],
                          )} to ${JSON.stringify(e)}`,
                          'forwardUris',
                        );
                        this.onEditArrChange(e, 'forwardUris');
                      }}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="savefaxes" sm={12} className="adv-modem-config">
                      Epik Cloud Based Fax Storages
                      <sup>
                        <InfoPopup
                          id="epikCloud"
                          text={TOOLTIPS_TEXT.ADV_EPIK_CLOUD}
                        />
                      </sup>
                    </Label>
                    <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Toggle
                        value={number.savefaxes || false}
                        onToggle={() => {
                          if (number && number.forwardUris.length !== 0) {
                            this.onEditArrChange(!!!number.savefaxes, 'savefaxes');
                          } else {
                            toast.info('Forward URI not configured!');
                          }
                        }}
                      />
                    </Col>
                    {/* eFax Only Toggle for fax t.37 */}
                    <Col sm={6}>
                      <Label for="eFaxOnly" sm={12} className="adv-modem-config" style={{ marginLeft: '-15px', marginTop: '20px' }}>
                        eFax Only
                        {/* <sup>
                          <InfoPopup id="eFaxOnly" text={TOOLTIPS_TEXT.eFaxOnly} />
                        </sup> */}
                      </Label>
                      <Toggle
                        value={this.state.onlyEfax} 
                        onToggle={this.handleToggle} 
                      />
                    </Col>
                  </Col>
                </FormGroup>
              </>
            )}
            {type === 'vmail' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Voicemail Recording Notification email(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.emails) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Voicemail Recording Notification email(s) Changed from ${JSON.stringify(
                            number?.emails || [],
                          )} to ${JSON.stringify(e)}`,
                          23,
                        );
                        this.onEditArrChange(e, 'emails');
                      }}
                      validator={util.validateEmail}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Greeting file (*.wav/.mp3 file)
                    </Label>
                    {this.state.loadingVmail ? (
                      <img
                        src={loadingSpinner}
                        alt="greeting file loading"
                        height="100px"
                        width="100px"
                      ></img>
                    ) : (
                      <>
                        <Input
                          type="file"
                          name="greetinFile"
                          accept="audio/mp3,audio/wav,audio/*;"
                          onChange={this.handleChangeUpload}
                          disabled={disabledAdmin}
                          style={{ color: 'transparent' }}
                        />
                        <div style={{ paddingTop: '10px' }}>
                          {this.state.vmailFile ? (
                            (typeof this.state.vmailFile === 'string' &&
                              this.state.vmailFile !== 'Error while getting voicemail file') ||
                            (typeof this.state.vmailFile === 'object' &&
                              this.state.vmailFile.failure) ? (
                              <>
                                <audio
                                  controls
                                  src={`data:audio/wav;base64,${this.state.vmailFile}`}
                                />
                                <p>File Name: greeting</p>
                              </>
                            ) : (
                              <p>No Voicemail File Found</p>
                            )
                          ) : (
                            <p>No Voicemail File Found</p>
                          )}
                        </div>
                      </>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Voicemail Recording Notification SMS Text Number(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.forwardNumbers) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Voicemail Recording Notification SMS Text Number(s) Changed from ${JSON.stringify(
                            number?.forwardNumbers || [],
                          )} to ${JSON.stringify(e)}`,
                          21,
                        );
                        this.onEditArrChange(e, 'forwardNumbers');
                      }}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            {type === 'dialout' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Allowed number(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.allowedNumbers) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Allowed number(s) Changed from ${JSON.stringify(
                            number?.allowedNumbers,
                          ) || []} to ${JSON.stringify(e)}`,
                          'allowedNumbers',
                        );
                        this.onEditArrChange(e, 'allowedNumbers');
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Forward number
                    </Label>
                    <Input
                      required
                      type="text"
                      name="forwardNumbers"
                      value={(number && number.forwardNumbers) || []}
                      onChange={this.onEditArrNumChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Caller ID
                    </Label>
                    <Input
                      required
                      type="text"
                      name="cid"
                      value={(number && number.cid) || []}
                      onChange={this.onEditUserChange}
                    />
                  </Col>
                  <Col sm={6}>
                    <Row>
                      <Col sm={12}>
                        <Label for="spoofIncomingCid" sm={6}>
                          <Input
                            type="checkbox"
                            id="spoofIncomingCid"
                            onChange={() => {
                              // [BulkAction] - Enable
                              enableBulkBoxSession('Spoof Incoming Cid Enabled', 28);
                              this.setCheckedBox(!number.spoofIncomingCid);
                            }}
                            checked={number.spoofIncomingCid}
                            disabled={
                              (number.cid && number.cid.length < 10) ||
                              number.cid === '' ||
                              number.cid === undefined
                            }
                          />
                          Spoof cid
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'prepend')}
                            disabled={!number.spoofIncomingCid}
                            checked={this.state.prepend}
                          />
                          prepend
                        </Label>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'append')}
                            disabled={!number.spoofIncomingCid}
                            checked={this.state.append}
                          />
                          append
                        </Label>
                        <Label check sm={6}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'same')}
                            disabled={!number.spoofIncomingCid}
                            checked={this.state.same}
                          />
                          Same called number
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <Label sm={12} for="numDigits">
                          Number of digits
                        </Label>
                        <Input
                          disabled={
                            !!(
                              number.spoofType === 'same' ||
                              number.spoofType === 'none' ||
                              !number.spoofIncomingCid
                            )
                          }
                          type="number"
                          id="numDigits"
                          name="numDigits"
                          onChange={this.handleNumberDigit}
                          value={number.numDigits}
                          max={3}
                          min={1}
                        />
                      </Col>
                      {this.state.cidOverride && this.state.cidOverride !== '' && (
                        <Col sm={6}>
                          <Label sm={12} for="numDigits">
                            Spoofed Cid
                          </Label>
                          <Input
                            disabled
                            type="text"
                            id="numDigits"
                            name="numDigits"
                            value={this.state.cidOverride}
                          />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </FormGroup>
              </>
            )}

            {type !== 'vmail' &&
              type !== 'dialout' &&
              type !== 'unassigned' &&
              type !== 'fax' &&
              type !== 'forward' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                  </Label>
                  <MultiInput
                    inputData={(number && number.forwardUris) || []}
                    onChange={e => {
                      // [BulkAction] - Change
                      changeBulkBoxSession(
                        `${type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'
                        } Changed from ${JSON.stringify(
                          number?.forwardUris || [],
                        )} to ${JSON.stringify(e)}`,
                        'forwardUris',
                      );
                      this.onEditArrChange(e, 'forwardUris');
                    }}
                    disabledAdmin={disabledAdmin}
                  />
                </Col>
                {(type === 'hunt' || type === 'modemHunt' || type === 't38hunt' ) && (
                  <Col sm={6}>
                    <Label for="type" sm={12} className="adv-modem-config">
                    {`Add port to ${type === 'hunt'
                            ? 'hunt'
                            : type === 'modemHunt'
                              ? 'modem hunt'
                              : type === 't38hunt'
                                ? 'fax hunt'
                                : ''
                          }`}
                    </Label>
                    {this.sortPort() && this.sortPort().length !== 0 ? (
                      <ButtonDropdown
                        isOpen={this.state.drop}
                        toggle={() => {
                          // [BulkAction] - Change
                          changeBulkBoxSession(
                            `Add port to hunt Changed from ${this.state.drop} to ${!this.state
                              .drop}`,
                            'addPortToHunt',
                          );
                          this.setState({ drop: !this.state.drop });
                        }}
                        style={{ width: '100%' }}
                      >
                        <DropdownToggle
                          style={{
                            borderRight: 'none',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                          }}
                          caret
                        >
                          {this.state.selectedPort || 'Select Port'}
                        </DropdownToggle>
                        <DropdownMenu
                          style={{
                            maxHeight: '300px',
                            overflow: 'hidden',
                            borderRight: 'none',
                            width: '100%',
                          }}
                        >
                          {this.sortPort().length !== 0 &&
                            this.sortPort().map((port, i) => (
                              <div key={i}>
                                <DropdownItem
                                  onClick={() => this.setPortName(port || `port ${i + 1}`)}
                                >
                                  {port || `port ${i + 1}`}
                                </DropdownItem>
                              </div>
                            ))}
                        </DropdownMenu>
                      </ButtonDropdown>
                    ) : (
                      <Alert colSpan={2} color="info" className="price-not-found-alert">
                        {`No ${type === 'hunt' ? 'hunt' : type === 'modemHunt' ? 'modem hunt' : '' } ports configured on this box yet`}
                      </Alert>
                    )}
                    {this.state.ports.length !== 0 && (
                      <>
                        <Label for="type" sm={12}>
                            Ring Order
                        </Label>
                        <MultiInputDrag
                          removePort={this.removePort}
                          mode="number-edit"
                          type="port"
                          defaultPort={selectedAta?.boxPortNumber}
                          customClass="port-dnd"
                          inputData={this.state.ports}
                          move={this.move}
                          disabledAdmin
                        />
                      </>
                    )}
                  </Col>
                )}
              </FormGroup>
            ) : (
              ''
            )}

            {type === 'fax' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12} className="adv-modem-config">
                    Confirmation email
                  </Label>
                  {number && (number?.forwardUris?.length !== 0 || false) ? (
                    <Input
                      type="email"
                      disabled={disabledAdmin}
                      placeholder="please specify"
                      value={number.confirmationEmail}
                      onChange={this.onEditConfirmationEmail}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Forward URI not configured
                    </Alert>
                  )}
                </Col>
                <Col sm={6}>
                  <Label for="deliveryConfirmations" sm={12} className="adv-modem-config">
                    Delivery Confirmations
                  </Label>
                  <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      value={number.faxDeliveryConfirmation}
                      onToggle={() => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Delivery Confirmations Changed from ${number.faxDeliveryConfirmation
                          } to ${!number.faxDeliveryConfirmation}`,
                          'deliveryConfirmation',
                        );
                        if (
                          number &&
                          (number?.forwardUris?.length !== 0 || false) &&
                          !disabledAdmin
                        ) {
                          this.onEditArrChange(
                            !number.faxDeliveryConfirmation,
                            'faxDeliveryConfirmation',
                          );
                        } else {
                          toast.info('Forward URI not configured!');
                        }
                      }}
                    />
                  </Col>
                </Col>
              </FormGroup>
            ) : null}

            {type === 'forward' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="number" sm={12}>
                    Forward Number
                  </Label>
                  <Input
                    required
                    type="text"
                    name="forwardNumbers"
                    value={number?.forwardNumbers ? number.forwardNumbers[0] : ''}
                    onChange={e => {
                      // [BulkAction] - Change
                      changeBulkBoxSession(
                        `Forward Numbers Changed from ${number?.forwardNumbers ? number.forwardNumbers[0] : '-'
                        } to ${e.currentTarget.value} `,
                        'forwardNumbers',
                      );
                      this.onEditArrChange([e.currentTarget.value], 'forwardNumbers');
                    }}
                    maxLength={12}
                  />
                </Col>
              </FormGroup>
            ) : null}

            {user.role === 'superAdmin' ||
              user.role === 'companyGroupAdmin' ||
              user.role === 'supportEngineer' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="number" sm={12}>
                    Route
                  </Label>
                  <NumberRoute
                    vmail={vmail}
                    number={number}
                    onChange={e => {
                      // [BulkAction] - Change
                      let rout = e?.currentTarget?.value?.gateway;
                      // console.log('e?.currentTarget?.gateway', e?.currentTarget?.value);
                      // console.log('e?.currentTarget?.gateway', e?.currentTarget?.value?.gateway);
                      // console.log(
                      //   'e?.currentTarget?.gateway',
                      //   e?.currentTarget?.value?.['gateway'],
                      // );

                      changeBulkBoxSession(
                        `Route Changed from ${JSON.stringify(number?.routeInfo) || '-'} to ${e?.currentTarget.value
                        }`,
                        'routeChanged',
                      );
                      this.onSelectRoute(JSON.parse(e.currentTarget.value));
                    }}
                  />
                  <p className="error-text" style={{ marginTop: 5 }}>
                    {number.supposedRoute != number.currentRoute &&
                      `Invalid route - valid route should be ${number.supposedRoute}. `}
                    {number.carrier === 'inteliquent' && (
                      <div
                        style={
                          number.supposedRoute == number.currentRoute ? { color: '#ffcc00' } : {}
                        }
                      >
                        For recent DC swaps click{' '}
                        <a onClick={this.onFetchRoutingOrderInfo} className="box-name-link">
                          HERE
                        </a>{' '}
                        to check status of the route change.
                      </div>
                    )}
                    </p>
                </Col>
                <Col className="px-4" sm={6}>
                  <div className="d-flex align-items-center">
                    <Label for="cnameEnable" className="mb-0">
                      <Input
                        type="checkbox"
                        id="cnameEnable"
                        // onChange={() => this.setState({ cnameEnable: !cnameEnable })}
                        onChange={() => {
                          this.setState(prevState => ({
                            cnameEnable: !prevState.cnameEnable,
                          }), () => {
                            if (!this.state.cnameEnable) {
                              editNumberFieldChange('callerIdName', '');
                            }
                          });
                        }}
                        checked={cnameEnable}
                      />
                      <span className="ml-2">Enable Customer Caller ID Name (CNAM)</span>
                    </Label>
                    <sup className="ml-2">
                      <InfoPopup
                        id="enableCustomer"
                        text={TOOLTIPS_TEXT.ADV_ENABLE_CUSTOMER_CALLER_ID_NAME}
                      />
                    </sup>
                  </div>
                  {cnameEnable && (
                    <>
                      <Label for="callerIdName" sm={12}>
                        Customer Caller ID Name (CNAM)
                      </Label>
                      <Input
                        type="text"
                        name="callerIdName"
                        placeholder="Please specify here"
                        value={number?.callerIdName || ''}
                        maxLength="15"
                        onChange={({ currentTarget }) => {
                          editNumberFieldChange('callerIdName', currentTarget.value);
                        }}
                      />
                    </>
                  )}
                </Col>
                {boxDetails.advancedRouting &&
                  number.carrier == 'inteliquent' &&
                  !['fax', 'faxStandard', 'vmail','t38hunt'].includes(number.type) &&
                  !vmail && (
                    <Col>
                      <Label>Inband Route</Label>
                      <Toggle
                        value={this.state.inbandRouting}
                        onToggle={() => {
                          editNumberFieldChange('inbandRouting', !this.state.inbandRouting);
                          this.setState({
                            inbandRouting: !this.state.inbandRouting,
                          });
                        }}
                      />
                    </Col>
                  )}
              </FormGroup>
            ) : null}
            <FormGroup row>
            {!['alarm', 'fireAlarm'].includes(type) && (
                <>
                  <Col sm={6}></Col>
                  <Col sm={6} className="px-4">
                  {this.state.callerIdMaskingAccess && 
                    <div className="d-flex align-items-center w-100">
                    <Toggle
                      value={callerIdMasking}
                      onToggle={this.onToggleCallerIDMask}
                      id="callerIdMasking"
                      disabled={this.state.callerIdMaskingAccess == 'read'}
                    />
                    <Label sm={12} className="adv-modem-config p-2">
                      Allow Caller ID Masking
                    </Label>
                    </div>
                  }
                    <div className="mt-2 w-75">
                      {callerIdMasking && callerIdMaskingNumber && !this.state.selectedFromAutoComplete && this.state.callerIdMaskingAccess == 'read' ? (
                        <input
                          type="text"
                          value={callerIdMaskingNumber}
                          disabled={this.state.callerIdMaskingAccess == 'read'}
                          className="form-control"
                        />
                      ) : (
                        <>
                          {callerIdMasking && CallerMaskingTypeNumbers.length !== 0 && 
                          (this.state.callerIdMaskingAccess === 'write' || this.state.callerIdMaskingAccess === 'both') ? (
                            <NumberAutocomplete
                              placeholder="Select Number"
                              numbers={CallerMaskingTypeNumbers}
                              searchTerm={callerIdMaskingNumber}
                              onChange={(selectedValue) => {
                                this.onCallerIdMaskingNumberChange(selectedValue);
                                this.setState({ selectedFromAutoComplete: true });
                              }}
                              includeCallIdMaskNumber={true}
                            />
                          ) : (
                            callerIdMasking && (
                              <Alert
                                colSpan={2}
                                color="info"
                                className="price-not-found-alert"
                              >
                                No Number(s) found
                              </Alert>
                            )
                          )}
                        </>
                      )}
                    </div>
                  </Col>
                </>
              )}

              <Col sm={6}>
                <Label for="type" sm={12}>
                  Allowed User(s)
                </Label>
                <UsersAutocomplete
                  disabledAdmin={disabledAdmin}
                  callsItem={(email && email.emails) || []}
                  allowedUsers
                  placeholder="Allowed users"
                  calls={(email && email.emails) || []}
                  onChange={this.onAllowedUserSelect}
                />
                <div className="email-list">
                  {number.allowedUsers &&
                    number.allowedUsers.map((value, idx) => {
                      return (
                        <div className="multi-input-item" key={value._id}>
                          <span className="item">{value.email}</span>
                          <img
                            className="remove-icon"
                            src={remove}
                            onClick={() => this.removeValue(idx)}
                            alt="remove"
                          />
                        </div>
                      );
                    })}
                </div>
              </Col>
              <Col className="px-4 d-flex justify-content-between align-items-center" sm={6}>
                <Toggle
                  value={number.inBoundCallBlocked}
                  onToggle={() => {
                    editNumberFieldChange('inBoundCallBlocked', !number.inBoundCallBlocked);
                  }}
                />
                <Label for="inBoundCallBlocked" sm={12} className="adv-modem-config p-2">
                  Block Inbound Calls
                  <sup>
                    <InfoPopup
                      id="blockInboud"
                      text={TOOLTIPS_TEXT.BLOCK_INBOUND_CALL}
                    />
                  </sup>
                </Label>
              </Col>
              <Col sm={6}></Col>
              <Col
                className={`px-4 d-flex justify-content-between align-items-center ${this.state.blockCallerId
                  } ${selectedPort ? selectedPort.blockCallerId : ''}`}
              >
                <Toggle
                  value={this.state.blockCallerId}
                  onToggle={() => {
                    const newBlockCallerIdValue = !this.state.blockCallerId;
                    this.props.blockCallerIdConfig(newBlockCallerIdValue);
                    if (selectedPort) {
                      this.setState({
                        blockCallerId: !this.state.blockCallerId,
                      });
                    }
                  }}
                />
                <Label for="blockCallerId" sm={12} className="adv-modem-config p-2">
                  Block Caller ID
                  <sup>
                    <InfoPopup
                      id="blockCallerId"
                      text={TOOLTIPS_TEXT.BLOCK_CALLER_ID}
                    />
                  </sup>
                </Label>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col className="px-4" sm={6} />
              <Col className="px-4" sm={6}>
                {/* <Label for="callIdOverride" sm={12}>
                  <Input
                    type="checkbox"
                    id="callIdOverride"
                    onChange={() => {
                      this.setState({ callIdOverride: !callIdOverride, portSelectedDid: '' });
                      callerIdOverride('');
                    }}
                    checked={callIdOverride}
                  />
                  Enable Call ID Override
                </Label>
                <sup>
                  <InfoPopup
                    id="enablecalloverride"
                    text={TOOLTIPS_TEXT.ADV_ENABLE_CALL_OVER_RIDER_ALARAM}
                  />
                </sup> */}

                <div className="d-flex align-items-center">
                  <Label for="callIdOverride" className="mb-0">
                    <Input
                      type="checkbox"
                      id="callIdOverride"
                      onChange={() => {
                        this.setState({ callIdOverride: !callIdOverride, portSelectedDid: '' });
                        callerIdOverride('');
                      }}
                      checked={callIdOverride}
                    />
                    <span className="ml-2">Enable Caller ID Display</span>
                  </Label>
                  <sup className="ml-1">
                    <InfoPopup
                      id="enablecalloverride"
                      text={TOOLTIPS_TEXT.ADV_ENABLE_CALL_OVER_RIDER_ALARAM}
                    />
                  </sup>
                </div>

                {callIdOverride && (
                  <>
                    <Input
                      type="select"
                      value={portSelectedDid || selectedPort?.callerIdOverride}
                      onChange={({ currentTarget }) => {
                        this.setState({ portSelectedDid: currentTarget.value });
                        callerIdOverride(currentTarget.value);
                      }}
                    >
                      <option value="">Please select any DID</option>
                      {portAssignedDids?.map((item, idx) => {
                        return (
                          <option key={idx} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </Input>
                  </>
                )}
              </Col>
            </FormGroup>
            {numberConfirmation && (
              <WarningModal
                body={
                  'Faxing services will be migrated to the Enhanced Fax protocol. Fax services may be interrupted during the migration process. Validate all fax settings after the migration is complete. Do you want to proceed?'
                }
                isOpen={!!numberConfirmation}
                onCancel={() => this.setState({ numberConfirmation: null })}
                onConfirm={() => {
                  this.setState({ numberConfirmation: null });
                  if (numberConfirmation.type === 'number')
                    this.onNumberSelect({ suggestion: numberConfirmation.data });
                  if (numberConfirmation.type === 'port')
                    this.onNumberTypeSelect(numberConfirmation.data);
                }}
              />
            )}
            {this.state.orderHistoryModal.length ? (
              <NumberOrderHistoryModal
                isOpen={this.state.orderHistoryModal.length ? true : false}
                data={this.state.orderHistoryModal}
                title={number.number}
                onCancel={() => this.setState({ orderHistoryModal: [] })}
              />
            ) : null}
          </div>
        </div>
        <DeleteModal
          message={deleteModalMsg}
          isOpen={this.state.deleteModalStatus}
          onCancel={() => this.setState({ deleteModalStatus: false })}
          onConfirm={async() => {
            if (this.state.selectedPortTypeData) {
              await this.onNumberTypeSelect(this.state.selectedPortTypeData, true);
              // Get flag from Redux state or instance property
              const portConfigChangesFromRedux = this.props.portConfigChangesMade;
              const portConfigChanges = portConfigChangesFromRedux || this.portConfigChangesMadeRef;
              await updatePort({ portConfigChangesMade: portConfigChanges });
              // Reset the instance property after passing it
              this.portConfigChangesMadeRef = false;
              // Clear Redux state if it exists
              if (this.props.clearPortConfigChangesMade) {
                this.props.clearPortConfigChangesMade();
              }
              }
          }}
        />
        <ConfirmationModal
          isOpen={Boolean(warningText)}
          onConfirm={this.onCustomWarningConfirm}
          onCancel={this.onCustomWarningCancel}
          bodyText={warningText}
        />
        {lineTypeChangeWarning && <WarningModal
          isOpen={lineTypeChangeWarning}
          onCancel={() => this.setState({ lineTypeChangeWarning: false })}
          onConfirm={() => {
            this.onPortConfigure()
          }}
          body={'LineType of number is changed. Do you want to customize port configuration settings?'}
          noButtonText="Cancel"
          yesButtonText={portConfigLoading ? <SpinnerCircles /> : "Yes"}
          loading={portConfigLoading}
        />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
  number: state.UIState.numbers.editNumber,
  numberByID: state.AppState.numbers.numberByID,
  company: state.UIState.numbers.editNumber.company,
  companies: state.AppState.companies,
  type: state.UIState.numbers.editNumber.type,
  email: state.UIState.numbers.filterNumbersByCompany.number,
  emails: state.UIState.numbers.editNumberFieldChange,
  selectedPort: state.UIState.epikBoxDetails.selectedPort,
  selectedAta: state.UIState.epikBoxDetails.selectedPort,
  assignedNumbers: state.AppState.obis.assignedNumbers || [],
  defaultTrunk: state.AppState.provisioning.trunkGroupList.defaultValue,
  box: state.AppState.boxDetails.box,
  selectedObi: state.UIState.epikBoxDetails.selectedObi,
  selectedPortConfigTemplate: state.UIState.epikBoxDetails.selectedPortConfigTemplate,
  portConfigChangesMade: state.UIState.epikBoxDetails.portConfigChangesMade
});

const mapDispatchToProps = dispatch => ({
  editNumberFieldChange: (name, value) => dispatch(editNumberFieldChangeAction(name, value)),
  getNumberOrderList: (token, numId) => dispatch(getNumberOrderList(token, numId)),
  editNumberField: (name, value) => dispatch(editNumberField(name, value)),
  editAssignedNumber: id => dispatch(editAssignedNumber(id)),
  assignRouteInfo: (token, numId) => dispatch(assignRouteInfo(token, numId)),
  editCompanyFieldChange: (name, value) => dispatch(editCompanyFieldChange(name, value)),
  editEmailFieldChange: emails => dispatch(editEmailFieldChange(emails)),
  getCompanyNumbers: (token, id, uid) => dispatch(getCompanyNumbers(token, id, uid)),
  getObiCallerOverRide: (token, id) => dispatch(getObiCallerOverRide(token, id)),
  getNumberByID: (token, id) => dispatch(getNumberByID(token, id)),
  getVoicePorts: (token, id) => dispatch(getVoicePorts(token, id)),
  getModemPorts: (token, id) => dispatch(getModemPorts(token, id)),
  getFaxHuntPorts: (token, id) => dispatch(getFaxHuntPorts(token, id)),
  uploadFile: (token, id, files) => dispatch(uploadFile(token, id, files)),
  editNumberCancel: () => dispatch(editNumberCancel()),
  changeAction: description => dispatch(changeAction(description)),
  changeBulkBoxSession: (description, key) => dispatch(changeBulkBoxSession(description, key)),
  enableBulkBoxSession: (description, key) => dispatch(enableBulkBoxSession(description, key)),
  resetBulkBoxSession: () => dispatch(resetBulkBoxSession()),
  advModemConfig: value => dispatch(advModemConfig(value)),
  callerIdOverride: value => dispatch(callerIdOverride(value)),
  blockCallerIdConfig: value => dispatch(blockCallerIdConfig(value)),
  getPortConfigTemplates: (token, dc, value, ataType,compID) => dispatch(getPortConfigTemplates(token, dc, value, ataType,compID)),
  getPortValues: (token, obiId, values) => dispatch(getPortValues(token, obiId, values)),
  getStateCountry: token => dispatch(getStateCountry(token)),
  resetSelectedNumbers: number => dispatch(ProvisioningActions.resetSelectedNumbers(number)),
  clearSearchedNumbers: () => dispatch(ProvisioningActions.clearSearchedNumbers()),
  setSelectedPortConfigTemplate: (template) => dispatch(setSelectedPortConfigTemplate(template)),
  clearPortConfigChangesMade: () => dispatch(clearPortConfigChangesMade()),
  setPortConfigChangesMade: (changesMade) => dispatch(setPortConfigChangesMade(changesMade)),
  setPortConfigModalSource: (source) => dispatch(setPortConfigModalSource(source)),
  clearPortConfigModalSource: () => dispatch(clearPortConfigModalSource()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditNumberForm);
